import { render } from "./MoneyCatchGame.vue?vue&type=template&id=6084f07e&scoped=true"
import script from "./MoneyCatchGame.vue?vue&type=script&lang=js"
export * from "./MoneyCatchGame.vue?vue&type=script&lang=js"

import "./MoneyCatchGame.vue?vue&type=style&index=0&id=6084f07e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6084f07e"]])

export default __exports__